import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";

/**
 * @function urlIsAMixCloudAddress Returns whether the URL is a MixCloud address
 * @param url
 */
export const urlIsAMixCloudAddress: (url: string) => boolean = (url: string) => {

  // get the regular expression pattern for the website
  const regEx: RegExp = RegularExpressions.MixCloud;

  // return the result of testing the given url against the regex pattern
  return regEx.test(url);
}
